import React, {  useState } from 'react' ;
import "./SpecificPerson.css" ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { getId, getToken, getUsername } from '../../RTK/Slice/Auth/AuthSlice';
import { Backdrop, Fade, Modal } from '@mui/material';
import ExtractModal from '../../Components/Utils/ExtractModal';
import { notEmpty } from '../../Validation';
import { extractDataFromDBAPI } from '../../RTK/Slice/Extract/ExtractDataFromDBSlice';
import { toast } from 'react-toastify';
import EgyptPng from "./../../Images/egypt.png" ; 
import IraqPng from "./../../Images/iraq.png" ; 
import UaePng from "./../../Images/uae.png" ; 
import UsaPng from "./../../Images/Flag_of_the_United_States.png" ; 
import yamenPng from "./../../Images/yemen.webp" ; 
import candaPng from "./../../Images/canda.png" ; 
import omanPng from "./../../Images/oman.png" ; 
import libyaPng from "./../../Images/libya.png" ; 
import KuweitPng from "./../../Images/Kuwait.png" ; 
import moroocoPng from "./../../Images/morocco.png" ; 
import qatarPng from "./../../Images/qatar.png" ; 
import algeriaPng from "./../../Images/algeria.png" ; 
import saudiPng from "./../../Images/sauid.png" ; 
import jordonpng from "./../../Images/jordon.png" ; 
import lebnanpng from "./../../Images/lebnan.png" ;
import syria from "./../../Images/syria.png"
import palestine from "./../../Images/palestine.png"

const SpecificPerson = () => {

    // For Access Search Text
    const [search , setSearchText] = useState('') ; 

    // For Handle set search text
    const handleSearchText = (e)=>{
        setSearchText(e.target.value)
    }

    // For Render Choose Country Modal
    const [chooseCountryModal , toogleCountryModal] = useState(false) ; 

    // For Control Show Country List
    const [showCountryList , setShowCountryList] = useState(false) ; 

    // For Choose Country state
    const [selectCountry , setSelecCountry] = useState({}) ;

    const countryModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        height : 250,
        maxWidth : "100%",
        p: 6,
        };

    // For Open Country Modal
    const handleOpenCountryModal = ()=>{
        toogleCountryModal(true) ; 
    }

    // For Close Country Modal
    const handleCloseCountryModal = ()=>{
        toogleCountryModal(false)
        setSelecCountry({}) ; 
        setShowCountryList(false) ; 
    }

    // For check (focus)
    const [focus , setFocus] = useState(false) ;

    // For Control Extract Modal
    const [openExtractModal, setOpenExtractModal] = useState(false);

    const handleExtractClose = () => setOpenExtractModal(false);

    // For Get User ID 
    const userID = useSelector(getId) ; 

    const handleExtractOpen = ()=>{
        if(notEmpty(search)){
            toogleCountryModal(false) ; 
            setOpenExtractModal(true) ; 
            dispatch(extractDataFromDBAPI({token , userId:userID, selectedID :search.split(",") , username , db_name : selectCountry.value })) ;
            setSelecCountry({}) ;
        }
    }

    // For Access Token
    const token = useSelector(getToken) ;
    
    // For Access Username
    const username = useSelector(getUsername) ; 

    // For Dispatch 
    const dispatch = useDispatch() ; 



    // For Search User Handler
    const extractUserHandler = (e)=>{
        e.preventDefault() ;
        if(notEmpty(token) ){
            if(notEmpty(search))
                handleOpenCountryModal() ; 
            else{
                toast.info("Please Enter IDs")
            }
            // dispatch(extractDataFromDBAPI({token , selectedID :arr , username})) ;
        }else{
            toast.info("Please Choose ID")
        }
    }


    // For Access Search In DB Data 
    const {data , status} = useSelector(state => state.ExtractDataFromDBSlice) ; 

    // For Render Extract Modal
    const renderExtractModal =  ()=>{
        return( 
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openExtractModal}
            onClose={handleExtractClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >
                <ExtractModal closeModal={handleExtractClose} data={data} status={status} />
        </Modal>
    )
    } 

    // For Render Message Modal
    const renderChoooseCountryModal = ()=>{
        return (
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={chooseCountryModal}
            onClose={handleCloseCountryModal}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >
            <Fade in={chooseCountryModal}>
                <div className='k-modal my-font' style={countryModalStyle}>

                    <div className='head'>
                        <div className='left'>
                            <h3>Extract Data</h3>
                            <p>Please select the country you want to search in.</p>
                        </div>
                        <div className='right'><FontAwesomeIcon onClick={handleCloseCountryModal} icon={faXmark} /></div>
                    </div>
                    <div className='body'>
                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>Choose Country </label>

                                <div className='choose-time' onClick={()=>setShowCountryList(!showCountryList)}>
                                <p>{selectCountry.country ? `${selectCountry.country}`: "Country"}</p>
                                <FontAwesomeIcon icon={faChevronDown} />
                                
                                <ul className={`list-items ${showCountryList ? "list-items-show": "" }`}>
                                    {/*<li onClick={()=>setSelecCountry({country : "Egypt" , value : "egy_db"})}  > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={EgyptPng} alt='flag' /> Egypt</li>*/}
                                    <li onClick={()=>setSelecCountry({country : "Algeria" , value : "algeria_db"})} ><img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={algeriaPng} alt='flag' /> Algeria</li>
                                    <li onClick={()=>setSelecCountry({country : "Canada" , value : "canada_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={candaPng} alt='flag' /> Canada</li>
                                    <li onClick={()=>setSelecCountry({country : "Egypt" , value : "extra_egy_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={EgyptPng} alt='flag' /> Egypt </li>
                                    <li onClick={()=>setSelecCountry({country : "Iraq" , value : "iraq_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={IraqPng} alt='flag' /> Iraq</li>
                                    <li onClick={()=>setSelecCountry({country : "Jordan" , value : "jordan_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={jordonpng} alt='flag' /> Jordan</li>
                                    <li onClick={()=>setSelecCountry({country : "Kuwait" , value : "kuwait_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={KuweitPng} alt='flag' /> Kuwait</li>
                                    <li onClick={()=>setSelecCountry({country : "Lebanon" , value : "lebanon_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={lebnanpng} alt='flag' /> Lebanon </li>
                                    <li onClick={()=>setSelecCountry({country : "Libya" , value : "libya_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={libyaPng} alt='flag' /> Libya</li>
                                    <li onClick={()=>setSelecCountry({country : "Morocco" , value : "morocco_db"})}> <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={moroocoPng} alt='flag' /> Morocco</li>
                                    <li onClick={()=>setSelecCountry({country : "Oman" , value : "oman_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={omanPng} alt='flag' /> Oman</li>
                                    <li onClick={()=>setSelecCountry({country : "Qatar" , value : "qatar_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={qatarPng} alt='flag' /> Qatar</li>
                                    <li onClick={()=>setSelecCountry({country : "Saudi Arabia" , value : "saudi_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={saudiPng} alt='flag' /> Saudi Arabia</li>
                                    <li onClick={()=>setSelecCountry({country : "United Arab Emirates (UAE)" , value : "uae_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={UaePng} alt='flag' /> United Arab Emirates (UAE)</li>
                                    <li onClick={()=>setSelecCountry({country : "United States of America (USA)" , value : "usa_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={UsaPng} alt='flag' /> United States of America (USA)</li>
                                    <li onClick={()=>setSelecCountry({country : "Yemen" , value : "yemen_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={yamenPng} alt='flag' /> Yemen</li>
                                    <li onClick={()=>setSelecCountry({country : "Syria" , value : "syria_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={syria} alt='flag' /> Syria</li>
                                    <li onClick={()=>setSelecCountry({country : "Palestine" , value : "palestine_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={palestine} alt='flag' /> Palestine</li>
                                </ul>
                                
                                
                            </div>

                        </div>
                    </div>

                    <div className='btn'>
                        <button onClick={handleExtractOpen}>Extract</button>
                    </div>

                </div>
                
            </Fade>
        </Modal>
        )
    }

  return (
    <section className='search-user-withid'>
        
        <form onSubmit={extractUserHandler} className='search-tools'>
            {renderExtractModal()}
            {renderChoooseCountryModal()}
            <div className= {`search ${focus ? 'search-focus' : ''}  `}>
                <input value={search} onChange={handleSearchText} autoFocus onFocus={()=>setFocus(true)} onBlur={()=>setFocus(false) }  placeholder='Enter User ID ex: 123**,435**,545**' />
                <FontAwesomeIcon icon={faMagnifyingGlass} />
            </div>
            <button type="submit" className='search-user-btn'>Search</button>
        </form>
    </section>
  )
}

export default SpecificPerson
